module.exports = __webpack_public_path__ + "img/cyba.89c0f864.png";